import type { TOC } from '@ember/component/template-only';
import { eq } from 'ember-truth-helpers';

interface OnboardingStepperStepIndicatorSignature {
  Args: {
    state: 'disabled' | 'active' | 'completed';
  };
  Element: HTMLDivElement;
}

export default <template>
  <div
    class="step-indicator
      {{if (eq @state 'active') 'step-indicator--active'}}
      {{if (eq @state 'completed') 'step-indicator--completed'}}"
    ...attributes
  >
    <div class="step-indicator__fill"></div>
    <div class="step-indicator__dot"></div>
  </div>
</template> satisfies TOC<OnboardingStepperStepIndicatorSignature>;
